<!-- header Start-->
<section class="event header" id="home">
    <div class="header3 bg">
        <div class="section-content">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 offset-xl-3 col-md-10 offset-md-1">
                        <div class="center-text" [@bounce]="{ value: bounce }">
                            <div class="text-center w-100">
                                <div class="h1-margin">
                                    <img src="assets/images/logo-banner.png" alt="Rapol App" style="max-height: 150px;">
                                </div>
                                <div class="wedding-time">
                                    <div class="container">
                                        <div class="welcome-box">
                                        <h1><span>Welcome! Everyone</span></h1>
                                        <p>A successfully set up to power your custom raffle draws. We’re getting everything ready — stay tuned!</p>
                                        <button (click)="login($event)">Start Your Raffle Now</button>
                                        </div>

                                        <div class="features-grid">
                                            <div class="feature"><div class="icon">🎨</div>Custom Design</div>
                                            <div class="feature"><div class="icon">⚡</div>Real-time Draw</div>
                                            <div class="feature"><div class="icon">📊</div>Analytics</div>
                                            <div class="feature"><div class="icon">🤖</div>AI Ready</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="set-bottom set-abs">
            <a class="center-content down" (click)="onRedirect($event)">
                <img src="assets/images/image-down.png" alt="" class="scroll-down">
            </a>
        </div>
    </div>
</section>
<!-- header end-->